export const INPUT_NAME_RESERVED_CANVAS1 = 'canvas1';

export const INPUT_NAME_RESERVED_CANVAS2 = 'canvas2';

export const INPUT_NAME_RESERVED_CANVAS_ARR = [
  INPUT_NAME_RESERVED_CANVAS1,
  INPUT_NAME_RESERVED_CANVAS2,
] as const;
